import React from 'react';
import { TextField, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

export interface AppSearchProps {
    /** Controlled value */
    value: string;
    /** Called when value changes */
    onChange: (value: string) => void;
    /** Called on key up (e.g. to trigger API search); optional */
    onSearch?: () => void;
    /** Placeholder text */
    placeholder?: string;
    /** Input size */
    size?: 'small' | 'medium';
    /** Optional class for the input (e.g. width) */
    className?: string;
    /** Disabled state */
    disabled?: boolean;
}

const defaultPlaceholder = 'Search';

export const AppSearch: React.FC<AppSearchProps> = ({
    value,
    onChange,
    onSearch,
    placeholder = defaultPlaceholder,
    size = 'small',
    className = 'w-full sm:w-64',
    disabled = false,
}) => {
    return (
        <TextField
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyUp={onSearch}
            disabled={disabled}
            InputProps={{
                startAdornment: <SearchIcon className="text-gray-400 mr-2" />,
                endAdornment: value ? (
                    <IconButton
                        size="small"
                        onClick={() => onChange('')}
                        className="!p-1"
                        disabled={disabled}
                    >
                        <ClearIcon className="text-gray-400" />
                    </IconButton>
                ) : null,
            }}
            size={size}
            className={className}
            sx={{
                '& .MuiOutlinedInput-root': {
                    backgroundColor: 'white',
                    borderRadius: '6px',
                    '& fieldset': {
                        borderColor: '#e5e7eb',
                    },
                    '&:hover fieldset': {
                        borderColor: '#d1d5db',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#0EA5E9',
                    },
                },
            }}
        />
    );
};

export default AppSearch;
